import React, { Component } from 'react';
import styled from 'styled-components';
import CountUp from 'react-countup';

// API 값은 숫자 롤링 효과로 표시 (값이 없으면 '—')
const rolling = (v, decimals) =>
  typeof v === 'number' && Number.isFinite(v) ? (
    <CountUp start={0} end={v} decimals={decimals} duration={2} separator="," />
  ) : (
    '—'
  );

// 상단 KPI 카드 (모든 탭 공통)
class KpiCards extends Component {
  render() {
    const { carrierSummary, todayPower, deviceStateCount } = this.props;
    // 운전 기기: 운전 중(RUNNING) 기기 수
    const { states } = deviceStateCount || {};
    const running = deviceStateCount
      ? (states || []).filter((x) => x.state === 'RUNNING').reduce((acc, x) => acc + (x.count || 0), 0)
      : null;
    const { consPowerCurrent, totalConsPower, heatingMeteringAmount } = carrierSummary || {};
    // 누적 난방 열량: API 값 × 1000
    const heatAmount = typeof heatingMeteringAmount === 'number' ? heatingMeteringAmount * 1000 : null;
    // 현재 소비전력: API 값 ÷ 1000
    const consPowerNow = typeof consPowerCurrent === 'number' ? consPowerCurrent / 1000 : null;
    // COP = 누적 난방 열량 / 누적 소비전력
    const cop = totalConsPower && heatAmount !== null ? heatAmount / totalConsPower : null;

    const kpis = [
      { label: '운전 기기', value: rolling(running, 0), unit: '대', meta: '운전 중' },
      { label: '평균 운전 COP', value: rolling(cop, 2), meta: '누적 난방 / 누적 소비전력', highlight: true },
      { label: '누적 소비전력', value: rolling(totalConsPower, 1), unit: 'kWh', meta: '집계 설비 누적' },
      { label: '누적 난방 열량', value: rolling(heatAmount, 1), unit: 'kWh', meta: '집계 설비 누적' },
      { label: '금일 소비전력', value: rolling(todayPower, 1), unit: 'kWh', meta: '금일 00:00부터' },
      { label: '현재 소비전력', value: rolling(consPowerNow, 2), unit: 'kW', meta: '집계 설비 실시간' },
    ];

    return (
      <Wrap>
        {kpis.map((kpi) => (
          <article key={kpi.label} className="kpi">
            <div className="kpi-label">{kpi.label}</div>
            <div className={`val ${kpi.highlight ? 'highlight' : ''}`}>
              {kpi.value} {kpi.unit && <small>{kpi.unit}</small>}
            </div>
            {/* 설명 문구(meta) 숨김 */}
          </article>
        ))}
      </Wrap>
    );
  }
}

const Wrap = styled.section`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;

  .kpi {
    min-width: 0;
    min-height: 122px;
    padding: 18px;
    background: linear-gradient(150deg, #131f31, #0f1929);
    border: 1px solid #243249;
    border-radius: 16px;
    box-shadow: 0 12px 28px #0002;
  }
  /* 전역 .label(comm-style.css) 과 충돌하지 않도록 kpi-label 사용 */
  .kpi-label {
    font-size: 16px;
    font-weight: 700;
    color: #9fb0c9;
  }
  .val {
    font-size: 31px;
    font-weight: 750;
    letter-spacing: -1px;
    margin: 14px 0 7px;
    text-align: center;
    white-space: nowrap;
    color: #edf3fc;

    &.highlight {
      color: #f6c96a;
    }
    small {
      font-size: 12px;
      color: #98acc8;
      font-weight: 500;
    }
  }
  .meta {
    font-size: 11px;
    color: #6fd2b1;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;

    .kpi {
      padding: 14px 12px;
      min-height: 106px;
    }
    .kpi-label {
      font-size: 13px;
    }
    .val {
      font-size: 24px;
      white-space: normal;
      overflow-wrap: anywhere;
      margin: 10px 0 6px;
    }
    .meta {
      font-size: 10px;
    }
  }
`;

export default KpiCards;
